import {
    FontWeights,
    getTheme,
    IconButton,
    mergeStyleSets,
    //DefaultButton,
    Modal,
    PrimaryButton,
    TextField,
} from "@fluentui/react";
import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";
import { Stack } from "@fluentui/react/lib/Stack";
import { CustomFontText } from "components/customFontText/CustomFontText";
import { styles } from "components/dialogs/employees/styles";
import { cancelIcon } from "constants/styles";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-grid-system";
import {
    useDispatch,
    useSelector
} from "react-redux";
import { AppState } from "store";
import * as Yup from "yup";
import { handleGetLocations } from "store/locations/locations.action";
import { Dropdown as PRDropdown } from 'primereact/dropdown';
import { handleImportDriveCentricLead } from "store/dealTracker/dealTracker.action";


interface IProps {
    isOpen?: any;
    onDismiss: any;
    handleSearchLead?: ({ dealNumber, locationId, customerLastName }) => void;
    primaryLocation?: any;
    retainData?: any;
}

export const ImportLeadDialog: React.FunctionComponent<IProps> = ({
    isOpen,
    onDismiss,
    handleSearchLead,
    primaryLocation,
    retainData
}) => {

    const loading = useSelector((state: AppState) => state.employees.loading);
    const [cityDealerList, setCityDealerList] = React.useState([]);
    const [createDealError, setCreateDealError] = useState("");
    const locations = useSelector((state: AppState) => state.locations.locations) as any;
    const dispatch = useDispatch();

    useEffect(() => {

        setCreateDealError('');
        dispatch<any>(handleGetLocations());

    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {

        if (locations && locations.results) {
            setCityDealerList(locations.results);
        } else {
            setCityDealerList(locations);
        }

    }, [locations]);


    const handleResponse = (response: any, error) => {
        if (typeof response === 'number') {
            onDismiss(response);
            window.scrollTo(0, 0);
        } else if (response && response?.length) {
            handleSearchLead({
                dealNumber: formik.values.dealNumber,
                locationId: formik.values.locationId,
                customerLastName: formik.values.customerLastName,
            });
            onDismiss(response);
        } else if (!response || !response.target) {
            onDismiss(response);
            handleSearchLead({
                dealNumber: formik.values.dealNumber,
                locationId: formik.values.locationId,
                customerLastName: formik.values.customerLastName,
            });
        }
    };

    const formik = useFormik({
        initialValues: {

            dealNumber: "",
            locationId: primaryLocation ? primaryLocation : "",
            customerLastName: ""
        },
        validationSchema: Yup.object({
            dealNumber: Yup.string().required("Deal Number required"),
            locationId: Yup.string().required("Location required"),
            customerLastName: Yup.string().required("Customer Last Name required")
        }),
        onSubmit: (values) => {

            const data = {
                dealNumber: values.dealNumber,
                locationId: values.locationId,
                customerLastName: values.customerLastName
            }
            
            dispatch<any>(
                handleImportDriveCentricLead({
                    deal: data,
                    callback: handleResponse,
                })
            );

        }
    });


    useEffect(() => {
        if (retainData) {
            formik.setValues(
                {
                    ...formik.values,
                    dealNumber: retainData.dealNumber,
                    locationId: retainData.locationId,
                    customerLastName: retainData.customerLastName,
                }
            );
        }
        // eslint-disable-line react-hooks/exhaustive-deps
    }, [retainData])// eslint-disable-line react-hooks/exhaustive-deps


    const handleCreateDeal = () => {
        formik.handleSubmit()
    }


    const renderSpinner = () => {
        return loading ? (
            <Spinner styles={styles.spinnerStyles} size={SpinnerSize.medium} />
        ) : null;
    };

    const onLocationChange = (e: { value: any }) => {
        formik.setValues(
            {
                ...formik.values,
                locationId: e.value,
            }
        );
    }

    const handleCustomerNumberChange = (e) => {
        formik.setValues(
            {
                ...formik.values,
                'customerLastName': e.target.value.trim()
            }
        );
    };

    const handlechangeDealNumber = (e) => {
        formik.setValues(
            {
                ...formik.values,
                'dealNumber': e.target.value.trim()
            }
        );
    };

    return (

        <Modal
            isOpen={isOpen}
            onDismiss={onDismiss}
            isBlocking={true}
            containerClassName={contentStyles.container}
            styles={{ root: { zIndex: 10 } }}
            className="createDealRecord createCustomerRecordWidth  updateEmployeeDialogHeight"
        >

            <div className={contentStyles.header + " inventory-popup"}>

                <CustomFontText className="formTitle">Import Lead</CustomFontText>
                <IconButton
                    styles={iconButtonStyles}
                    iconProps={cancelIcon}
                    ariaLabel="Close popup modal"
                    onClick={onDismiss}
                />
            </div>
            <div className={contentStyles.body + " deal-popup-body"} style={{ paddingBottom: "100px" }}>


                <Stack>
                    {
                        createDealError ?
                            <div>
                                <Row>
                                    <Col>
                                        <p className="genericErrorColor"><span>{createDealError}</span></p>
                                    </Col>
                                </Row>
                            </div> : null
                    }
                    <Row>
                        <Col md={6} className="columnBtwSpace">
                            <TextField
                                id="dealNumber"
                                name="dealNumber"
                                label="Deal Number"
                                placeholder=""
                                autoComplete="off"
                                value={formik.values.dealNumber}
                                required={true}
                                onChange={handlechangeDealNumber}
                                onBlur={formik.handleBlur}
                                errorMessage={
                                    formik.touched && formik.touched.dealNumber &&
                                    formik.errors && formik.errors.dealNumber &&
                                    formik.errors.dealNumber.toString()
                                }
                            />
                        </Col>
                        <Col md={6} className="columnBtwSpace location-p-dropdown-items">
                            <label className="lbl-text required-Label">Location</label>
                            <PRDropdown
                                id="location"
                                placeholder=""
                                value={formik.values.locationId}
                                options={cityDealerList}
                                onChange={onLocationChange}
                                optionLabel="legalName"
                                optionValue="id"
                                appendTo="self"
                                className="location-p-dropdown-items custom-p-dropdown .customInputField "
                                filter={false}
                                resetFilterOnHide={true}
                            />
                            <span className="error-message">
                                {
                                    formik.touched && formik.touched.locationId &&
                                    formik.errors && formik.errors.locationId &&
                                    formik.errors.locationId.toString()
                                }
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} className="deal-cust-number columnBtwSpace" >
                            <TextField
                                id="customerLastName"
                                name="customerLastName"
                                label="Customer Last Name"
                                placeholder=""
                                autoComplete="off"
                                value={formik.values.customerLastName}
                                required={true}
                                onChange={handleCustomerNumberChange}
                                onBlur={formik.handleBlur}
                                errorMessage={
                                    formik.touched && formik.touched.customerLastName &&
                                    formik.errors && formik.errors.customerLastName &&
                                    formik.errors.customerLastName.toString()
                                }
                            />
                        </Col>
                        <Col md={6} className="deal-cust-number columnBtwSpace createCusFootBtn" style={{ paddingTop: "30px", textAlign: "right" }}>
                            <PrimaryButton
                                // disabled={!formik.dirty || !formik.isValid}
                                 onRenderIcon={renderSpinner}
                                text="Search"
                                onClick={handleCreateDeal}
                            //className="btnHoverColor"
                            />

                        </Col>
                    </Row>
                </Stack>
            </div>
        </Modal>
    );
};

const theme = getTheme();
const contentStyles = mergeStyleSets({
    container: {
        // width: "50%",
        width: 480,
        // display: 'flex',
        // flexFlow: 'column nowrap',
        // alignItems: 'stretch',
        zIndex: 100,
    },
    header: {
        flex: "1 1 auto",
        borderTop: `4px solid ${theme.palette.themePrimary}`,
        color: theme.palette.neutralPrimary,
        display: "flex",
        alignItems: "center",
        fontWeight: FontWeights.semibold,
        padding: "5px 30px",
    },

    body: {
        // flex: "4 4 auto",
        // padding: "0 24px 24px 24px",
        //   padding: '75px',
        paddingLeft: 80,
        paddingRight: 80,
        paddingBottom: "34px",
        // overflowY: "hidden",
        selectors: {
            p: { margin: "14px 0" },
            "p:first-child": { marginTop: 0 },
            "p:last-child": { marginBottom: 0 },
        },
    },
    footer: {
        padding: "0px 30px",
        paddingBottom: 15,
    },
});
const iconButtonStyles = {
    root: {
        color: theme.palette.neutralPrimary,
        marginLeft: "auto",
        marginTop: "4px",
        marginRight: "2px",
    },
    rootHovered: {
        color: theme.palette.neutralDark,
    },
};
